import { useSWRConfig } from 'swr';
import { sleep } from '../utils/helpers';

/**
 * The useGrispiMutation function is a custom hook in TypeScript React that triggers a mutation using
 * useSWRConfig based on a specified mutation key, revalidation flag, and data.
 * @param  - The `useGrispiMutation` function takes in the following parameters:
 * @returns The `useGrispiMutation` function is returning a call to the `mutate` function from
 * `useSWRConfig` with the following parameters:
 * 1. A callback function that checks if the key starts with the provided `mutationKey`.
 * 2. The `data` parameter which is of type `T`.
 * 3. An options object with the `revalidate` property set to the provided
 */
export default function useGrispiMutation() {
    const { mutate } = useSWRConfig();
    const mutation = async (mutationKey: string | string[]) => {
        if (Array.isArray(mutationKey)) {
            mutationKey.forEach(
                async (mutationK) =>
                    await mutate((key) => {
                        return (
                            (typeof key === 'string' && key.startsWith(mutationK)) ||
                            (Array.isArray(key) && key[0].startsWith(mutationK))
                        );
                    })
            );
        } else {
            await mutate((key) => {
                return (
                    (typeof key === 'string' && key.startsWith(mutationKey)) ||
                    (Array.isArray(key) && key[0].startsWith(mutationKey))
                );
            });
        }
    };

    return {
        mutate: async (mutationKey: string | string[]) => {
            //apiden elastic e giden degisiklik daha indexlenmeden mutation yaptigimiz icin eski verileri aliyoruz. yenisini alabilmek icin 1sn lik bekleme sonrasi tekrar mutation yapiyoruz
            await mutation(mutationKey);
            await sleep(500);
            await mutation(mutationKey);
            await sleep(500);
            await mutation(mutationKey);
        }
    };
}
